module.exports = __webpack_public_path__ + "static/media/mg.446ae5d5.svg";